import * as React from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";

import {
    InitializeQATypeAsyncAction,
    SelectQATypeAction,
    SendForQAReviewOrAdditionalCoughCountAsyncAction
} from "../ManuallySendForQAModal/ManuallySendActions";
import Modal from "../../misc/components/modal";
import { CoughAnalysisSetType } from "../../misc/api/apiTypes";
import Loading from "../../misc/components/loading";
import { MainState } from "../../Core/reducers";
import AsyncActionButton from "../../misc/components/AsyncActionButton";
import { CoughAnalysisSet } from "webportalclient";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";

export interface ManuallySendForQAModalOwnProps {
    analysisSet: CoughAnalysisSet;
    onClose: () => void;
}
    
export interface ManuallySendForQAModalProps extends ManuallySendForQAModalOwnProps {
    isFetching: boolean;
    qaTypes: Array<CoughAnalysisSetType>;
    selectedQAType: string;

    dispatch?: Dispatch<MainState>;
}

export const ManuallySendForQAModal = (props: ManuallySendForQAModalProps) => {
    const legacyClient = useWebPortalLegacyClient();
    const { study } = useCurrentStudyConfigurationContext();

    React.useEffect(() => {
        props.dispatch(InitializeQATypeAsyncAction.create(legacyClient));
    }, []);

    const renderQATypesSelect = () => {
        if (props.qaTypes) {
            return (
                <select
                    className="form-control"
                    value={props.selectedQAType}
                    onChange={e => props.dispatch(SelectQATypeAction.create(e.target.value))}
                >
                    {props.qaTypes.map(i => (
                        <option key={i.Id} value={i.Id}>
                            {i.Name}
                        </option>
                    ))}
                </select>
            );
        } else if (props.isFetching) {
            return <Loading />;
        } else {
            return null;
        }
    };

    return (
        <Modal
            show={true}
            closeModalHandler={() => props.onClose()}
            header="Manually send for QA Review"
        >
            <div className="modal-body">{renderQATypesSelect()}</div>
            <div className="modal-footer">
                <AsyncActionButton
                    isSubmitting={props.isFetching}
                    className="btn btn-primary"
                    onClick={() =>
                        props.dispatch(
                            SendForQAReviewOrAdditionalCoughCountAsyncAction.create(
                                legacyClient,
                                props.analysisSet.id,
                                props.selectedQAType,
                                study.id,
                                props.onClose
                            )
                        )
                    }
                >
                    Send for QA Review
                </AsyncActionButton>
                <button
                    className="btn btn-outline btn-primary"
                    onClick={() => props.onClose()}
                >
                    Close
                </button>
            </div>
        </Modal>
    );
}

function mapStateToProps(state: MainState, ownProps: ManuallySendForQAModalOwnProps): ManuallySendForQAModalProps {
    return {
        analysisSet: ownProps.analysisSet,
        onClose: ownProps.onClose,
        isFetching: state.manuallySendModal.isFetching,
        qaTypes: state.manuallySendModal.qaTypes,
        selectedQAType: state.manuallySendModal.selectedQAType
    };
}

export default connect<ManuallySendForQAModalProps, any, ManuallySendForQAModalOwnProps>(mapStateToProps)(ManuallySendForQAModal);
